import styled from "styled-components";

export const Shimmer = styled.div`
    width: 100%;
    border-radius: 8px;
    background: var(--vo-cloud);
    background-image: linear-gradient(to right, var(--vo-cloud) 0%, var(--vo-white) 20%, var(--vo-cloud) 40%, var(--vo-cloud) 100%);
    background-repeat: no-repeat;
    animation : shim infinite 1.2s linear;

    @keyframes shim {
        0% { background-position: -800px 0;}
        100% { background-position: 800px 0;}
    }
`